import { FieldDefinition } from "./fieldDefinitions";

export interface DocumentTypeDto {
  documentTypeId: number;
  documentDescr: string;
  documentRemarks?: string;
}

export const documentTypeFields: FieldDefinition[] = [
  {
    name: "documentDescr",
    label: "Περιγραφή Τύπου Εγγράφου",
    type: "text",
    required: true,
  },
  {
    name: "documentRemarks",
    label: "Παρατηρήσεις",
    type: "text",
    required: false,
  },
] as const;

export const DocumentTypeKeyId = "documentTypeId" as const;
export const documentTypeFilters = documentTypeFields.filter((f) =>
  ["documentDescr", "documentRemarks"].includes(f.name),
);

export const documentTypeFormData: string[] = [
  "documentDescr",
  "documentRemarks",
];
